<template>
    <v-form ref="form">
        <v-row>
            <v-col cols="12" md="3">
                <v-text-field
                    label="Code"
                    :value="form.code"
                    outlined
                    dense
                    disabled
                    hide-details="auto"
                    background-color="disabled"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <DatePicker
                    label="Date"
                    v-model="form.date"
                    :rules="[isRequired]"
                    outlined
                    hide-details="auto"
                    dense
                />
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
                <v-text-field
                    label="Stock Transfer Code"
                    :value="form.stock_transfer_code"
                    disabled
                    outlined
                    dense
                    hide-details>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-autocomplete 
                    label="Source Warehouse"
                    :value="form.source_warehouse_id"
                    :items="warehouses"
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                    outlined
                    dense
                    readonly
                    hide-details="auto"
                    @update:search-input="searchWarehouses"
                >
                </v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" md="3">
                <v-autocomplete 
                    label="Destination Warehouse"
                    :value="form.destination_warehouse_id"
                    :items="warehouses"
                    item-text="display_name"
                    item-value="id"
                    :rules="[isRequired]"
                    outlined
                    dense
                    disabled
                    hide-details="auto"
                    @update:search-input="searchWarehouses"
                >
                </v-autocomplete>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col>
                <TransferReceiptVoucherFormLine
                    v-for="(line, index) in form.lines"
                    :key="line.key"
                    @deleteLine="handleDeleteLine(index)"
                    v-model="form.lines[index]"
                    :items="items"
                    :itemsLoading="itemsLoading"
                    @update:items-search-input="searchItems"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <v-btn block depressed small @click="addLine">
                    <v-icon left>mdi-playlist-plus</v-icon>
                    add line
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-textarea
                    label="Notes"
                    v-model="form.notes"
                    outlined
                    dense
                    hide-details="auto">
                </v-textarea>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from "./../../../utils/validations"
import TransferReceiptVoucherFormLine from './TransferReceiptVoucherFormLine.vue'
import DatePicker from './../../../components/common/DatePicker.vue';
import { v4 as uuid } from 'uuid';
import warehouseAPI from './../../../services/stock/warehouse';
import itemAPI from './../../../services/stockJournal/Item';

import moment from 'moment';

export default {
    components: {
        DatePicker,
        TransferReceiptVoucherFormLine,
    },
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                code: "STR -----",
                stock_transfer_id: null,
                stock_transfer_code: null,
                date: moment().format("YYYY-MM-DD"),
                source_warehouse_id: null,
                target_warehouse_id: null,
                lines: [],
                notes: null
            },
            line: {
                item_id: null,
                quantity: null,
                measure_unit_id: null,
                price: 0,
                key: null
            },
            warehouses: [],
            warehousesLoading: false,
            items: [],
            itemsLoading: false
        }
    },
    watch: {
        form: {
            handler(form) {
                this.$emit("input", {...form, lines: [...form.lines]});
            },
            deep: true
        }
    },
    methods: {
        isRequired,
        addLine() {
            this.form.lines.push({...this.line, key: uuid()})
        },
        handleDeleteLine(index){
            this.form.lines.splice(index, 1)
        },
        validate() {
            return this.$refs.form.validate();
        },
        searchWarehouses(query) {
            this.warehousesLoading = true;
            warehouseAPI.searchWarehouse(query).then(response => {
                this.warehouses = Array.from(new Set([...this.warehouses, ...response.data]));
            }).finally(() => {
                this.warehousesLoading = false;
            })
        },
        searchItems(query) {
            this.itemsLoading = true;
            itemAPI.search(query).then(response => {
                this.items = Array.from(new Set([...this.items, ...response.data]));
            }).finally(() => {
                this.itemsLoading = false;
            })
        }
    },
    created() {
        if(this.value) {
            this.form = {...this.form, ...this.value};

            if(this.form.source_warehouse) {
                this.warehouses = [...this.warehouses, this.form.source_warehouse];
            }

            if(this.form.destination_warehouse) {
                this.warehouses = [...this.warehouses, this.form.destination_warehouse];
            }

            if(Array.isArray(this.value.lines)) {
                this.form.lines = [...this.value.lines]
                this.form.lines.forEach(each => {
                    this.items = Array.from(new Set([...this.items, each.item]))
                })
            }
            
        }
    },
    mounted() {
        if(this.form.lines.length == 0) {
            this.addLine();
        }
    }
}
</script>

<style>

</style>